<template>
  <pt-previous-video-audit class="pt-previous-video-audit__withData"></pt-previous-video-audit>
</template>

<script>
import PtPreviousVideoAudit from './index'
export default {
  name: 'pt-previous-video-audit__withData',
  components: {
    'pt-previous-video-audit': PtPreviousVideoAudit
  }
}
</script>
